<template>
    <!-- The command counterpart of the suggested questions above: same idea,
         deliberately a different shape, because these are typed calls and not
         sentences. A click fills the composer and hands the caret over — it
         never sends, since most commands still need a domain. -->
    <div v-if="enabled && shown.length > 0" class="mt-6 flex w-full flex-col">
        <p
            class="mb-3 text-center text-[11px] font-medium uppercase tracking-wide text-gray-400"
        >
            {{ t("vue.ai_slash_examples_title") }}
        </p>
        <div class="flex flex-wrap justify-center gap-1.5">
            <button
                v-for="command in shown"
                :key="command.command"
                type="button"
                class="inline-flex cursor-pointer items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 font-mono text-xs text-gray-600 transition hover:border-[#FF421E]/40 hover:bg-[#FF421E]/5 hover:text-[#FF421E]"
                :title="t(`vue.${command.translation_key}`)"
                @click="$emit('select', command.example)"
            >
                <CommandLineIcon class="h-3.5 w-3.5 shrink-0 text-gray-400" />
                {{ command.example }}
            </button>
        </div>
        <p class="mt-2 text-center text-[11px] text-gray-400">
            {{ t("vue.ai_slash_examples_hint") }}
        </p>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { CommandLineIcon } from "@heroicons/vue/24/outline";
import { useAiSlashCommands } from "@/composables/useAiSlashCommands";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

const props = withDefaults(defineProps<{ limit?: number | null }>(), {
    limit: null,
});

defineEmits<{ (event: "select", command: string): void }>();

// The examples read the same server-owned catalogue the suggester does, so a
// new command shows up here without a second list to maintain.
const draft = ref("");
const { enabled, featured } = useAiSlashCommands(draft);

const shown = computed(() =>
    props.limit === null
        ? featured.value
        : featured.value.slice(0, props.limit),
);
</script>
